export default __webpack_public_path__ + "static/calmav-873ebe432262dbabb9455193c0f41334.png";